import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDro_eRfVld6JqPnIkS7H5pKKH9XolyksE",
  authDomain: "company-sync.firebaseapp.com",
  databaseURL: "https://company-sync-default-rtdb.firebaseio.com",
  projectId: "company-sync",
  storageBucket: "company-sync.appspot.com",
  messagingSenderId: "792501819706",
  appId: "1:792501819706:web:0c920f58556baf53c0d803",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
